import { useState } from 'react';
import { Sparkles } from 'lucide-react';
import AIChatPanel from './AIChatPanel';

/**
 * Floating chatbot bubble — Concierge for landing / user / driver views.
 * Auth is optional: /api/ai/concierge requires a logged-in user, so this
 * launcher hides itself if no token is present.
 */
export default function AIConciergeLauncher() {
  const [open, setOpen] = useState(false);
  const hasToken = typeof window !== 'undefined' && !!localStorage.getItem('token');
  if (!hasToken) return null;

  return (
    <>
      {!open && (
        <button
          onClick={() => setOpen(true)}
          className="fixed bottom-6 right-6 z-40 w-14 h-14 rounded-full bg-gradient-to-br from-orange-500 to-orange-600 text-white shadow-2xl hover:scale-105 transition-transform flex items-center justify-center"
          aria-label="Open LocalMove Concierge"
          data-testid="ai-concierge-launcher"
        >
          <Sparkles className="w-6 h-6" />
        </button>
      )}
      <AIChatPanel
        open={open}
        onClose={() => setOpen(false)}
        endpoint="/ai/concierge"
        title="LocalMove Concierge"
        subtitle="Ask about pricing, coverage, or how it works"
        testIdPrefix="ai-concierge"
        starterPrompts={[
          'How much for a ride to STL Airport?',
          'Where do you deliver?',
          'How do I become a driver?',
          'Do you deliver from CVS Pharmacy?',
        ]}
      />
    </>
  );
}
